module.exports = __webpack_public_path__ + "img/making-2.2ae2a1a6.png";